/**
 * Browser drafts that belong to one signed-in user (security review, V104-G-10..G-12).
 * Keys are `<prefix><userId>:<itemId>` and every such key is removed on sign-out.
 */
export const AUTHOR_RULE_DRAFT_PREFIX = 'gacpro:author-rule:';

/** Remove every rule-authoring draft on this device (called on sign-out). */
export function clearUserDrafts(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(AUTHOR_RULE_DRAFT_PREFIX)) keys.push(k);
    }
    for (const k of keys) window.localStorage.removeItem(k);
  } catch {
    // Storage blocked: nothing was kept.
  }
}
